import { DeployedEnv } from '@typesApp/Config'
import bundlehostDev from './bundlehost-dev.json'
import bundlehostProd from './bundlehost-prod.json'
import bundlehostStage from './bundlehost-stage.json'
import bundlehostTest from './bundlehost-test.json'

interface BrandHost {
  [brand: string]: string
}

interface EnvBrandHost {
  env: DeployedEnv
  host: string
}

const bundlehostConfig = {
  DEV: { ...bundlehostDev },
  TEST: { ...bundlehostTest },
  STAGE: { ...bundlehostStage },
  PROD: { ...bundlehostProd },
} as Record<'DEV' | 'TEST' | 'STAGE' | 'PROD', BrandHost>

// flatten hosts for all envs
const hostsDev = Object.keys(bundlehostConfig.DEV).map(brand => ({
  host: bundlehostConfig.DEV[brand],
  env: DeployedEnv.DEV,
}))
const hostsTest = Object.keys(bundlehostConfig.TEST).map(brand => ({
  host: bundlehostConfig.TEST[brand],
  env: DeployedEnv.TEST,
}))
const hostsStage = Object.keys(bundlehostConfig.STAGE).map(brand => ({
  host: bundlehostConfig.STAGE[brand],
  env: DeployedEnv.STAGE,
}))
const hostsProd = Object.keys(bundlehostConfig.PROD).map(brand => ({
  host: bundlehostConfig.PROD[brand],
  env: DeployedEnv.PROD,
}))

export const bundleHostList: EnvBrandHost[] = [...hostsDev, ...hostsTest, ...hostsStage, ...hostsProd]
